import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";

const Hero = () => {
  const heroImageUrl = "/FILAMEN%281%29.png";

  return (
    <div
      className="relative w-full h-[600px]  bg-center"
      style={{ backgroundImage: `url(${heroImageUrl})` }}
    >
      {/* Dark Overlay */}
      <div className="absolute inset-0 bg-black bg-opacity-30"></div>

      {/* Hero Content */}
      <div className="absolute bottom-10 left-1/2 transform underline -translate-x-1/2 text-white text-center">

        <Link to="/allproducts">
          <motion.p
            className="text-sm md:text-lg uppercase poppins tracking-widest"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1 }}
          >
            Explore Our New Collection
          </motion.p>
        </Link>
      </div>
    </div>
  );
};

export default Hero;
